import type { RouteLocationNormalizedLoaded, RouteLocationRaw, Router } from "vue-router";
import { applyH5Query, isH5Mode } from "@/utils/h5-mode";

export function installH5Routing(router: Router) {
  // RouterLink uses resolve() to generate hrefs. Preserve mode for new tabs too.
  const resolve = router.resolve.bind(router);
  router.resolve = (to: RouteLocationRaw, current?: RouteLocationNormalizedLoaded) => {
    const target = resolve(to, current);
    return isH5Mode() && target.query.h5 === undefined
      ? resolve({ path: target.path, query: { ...target.query, h5: "true" }, hash: target.hash }, current)
      : target;
  };

  router.beforeEach((to) => {
    applyH5Query(to.query.h5);
    if (isH5Mode() && to.query.h5 !== "true") {
      return { path: to.path, query: { ...to.query, h5: "true" }, hash: to.hash, replace: true };
    }
    return true;
  });
}
